











import Vue from 'vue'
import FilterDropdown from '@/pages/common/filter-dropdown/FilterDropdown.vue'
import { DropdownItem } from '@/pages/common/types'
import { LessonsAssignBlock } from '@/pages/learning/learning-lessons/create/model/assignment-block.model'
import { DropdownAssignmentBlockNames } from '@/pages/learning/learning-lessons/create/model/types'

export default Vue.extend({
  components: {
    FilterDropdown,
  },
  props: {
    label: String,
    blockId: Number,
  },
  effector: {
    ...LessonsAssignBlock.modules.subjectsDropdownModel.store,
    $subjects: LessonsAssignBlock.store.$subjects,
    $selectedSubject: LessonsAssignBlock.store.$selectedSubject,
  },
  methods: {
    ...LessonsAssignBlock.modules.subjectsDropdownModel.methods,
    onSelectItem(item: DropdownItem | null) {
      LessonsAssignBlock.methods.setSelectedType({
        value: {
          name: '',
          title: '',
        },
        type: DropdownAssignmentBlockNames.theme,
        id: this.blockId,
      })
      LessonsAssignBlock.methods.setSelectedType({
        value: item || null,
        type: DropdownAssignmentBlockNames.subject,
        id: this.blockId,
      })
    },
  },
})
